import { render } from "./AboutPage.vue?vue&type=template&id=0541c5c8&scoped=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0541c5c8"

export default script